import { useMsal } from "@azure/msal-react";
import { stopAlgoBulk } from "./lazerApi";
import { useNotification } from "./contexts/notifications";
import { useListedAlgo } from "./contexts/listAlgosContext";
import { Badge, Box, Button } from "@mui/material";
import DeleteIcon from "@mui/icons-material/Delete";
import { useEffect, useRef } from "react";
import { queryClient } from "../../api/queryClient";
import { selectedRowColor } from "./datagrids/shared/gridStyle";

const StopSelectedButton = () => {
  const { addNotification } = useNotification();
  const msal = useMsal();
  const { selectedAlgos, setSelectedAlgos, addPreventClearAlgosRef } =
    useListedAlgo();

  const excludedRef = useRef(null);
  useEffect(() => {
    addPreventClearAlgosRef(excludedRef);
  }, [addPreventClearAlgosRef]);

  const makeRequest = async () => {
    const ids = selectedAlgos.map((algo) => algo.algo_id);
    setSelectedAlgos([]);
    console.log("Stopping algos: ", selectedAlgos);
    stopAlgoBulk(msal, ids)
      .then(() => {
        queryClient.invalidateQueries({
          queryKey: ["v1/algos"],
        });
        addNotification("Selected algos will be stopped", "success");
      })
      .catch((error) => {
        console.error("Failed to stop selected algos: ", error);
        addNotification("Failed to stop selected algos", "error");
      });
  };

  return (
    <Box ref={excludedRef} display={"flex"} flexDirection={"row"} gap={1}>
      <Badge
        badgeContent={selectedAlgos.length}
        sx={{
          "& .MuiBadge-badge": {
            backgroundColor: selectedRowColor,
            color: (t) => t.palette.getContrastText(selectedRowColor(t)),
            top: 6,
            lineHeight: 0,
            border: "2px solid",
            borderColor: (t) =>
              t.palette.mode === "dark"
                ? "#283641"
                : t.palette.background.default,
            padding: "0 0",
          },
        }}
      >
        <Button
          disabled={!selectedAlgos.length}
          variant="contained"
          onClick={makeRequest}
          color="error"
          endIcon={<DeleteIcon />}
        >
          Delete selected
        </Button>
      </Badge>
    </Box>
  );
};

export { StopSelectedButton };
